import { render, staticRenderFns } from "./EditableOneProduct.vue?vue&type=template&id=10129331&"
import script from "./EditableOneProduct.vue?vue&type=script&lang=js&"
export * from "./EditableOneProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports